import { Controller } from '@hotwired/stimulus'

import { withSummaryItems } from '../src/mixins/with_summary_items'

export default class extends Controller {
  static targets = ['totalFlights', 'averageAirtime', 'totalAirtime', 'totalPilots']

  connect () {
    withSummaryItems(this)
  }

  update ({ detail: { totalFlights, averageAirtime, totalAirtime, totalPilots } }) {
    this.presentSummaryItemNumber(this.totalFlightsTarget, totalFlights)
    this.presentSummaryItemNumber(this.averageAirtimeTarget, averageAirtime)
    this.presentSummaryItemNumber(this.totalAirtimeTarget, totalAirtime)
    this.presentSummaryItemNumber(this.totalPilotsTarget, totalPilots)
  }
}
